import React from 'react';

import { GalleryWrapper, Image, ImageButton, ShowAllButton } from './wrappers';
interface IEnvironmentImage {
  alt?: string;
  url: string;
}

interface IEnvironmentImageGallery {
  images: IEnvironmentImage[];
  onImageClick: (index: number) => void;
  onShowAll: () => void;
}

const EnvironmentImageGallery = ({ images, onImageClick, onShowAll }: IEnvironmentImageGallery) => {
  const showAllButton = images.length > 4;

  return (
    <GalleryWrapper>
      {images.slice(0, 4).map(({ alt, url }, i) => (
        <ImageButton onClick={() => onImageClick(i)} type="button" key={url}>
          <Image src={url} alt={alt} key={`envimg-${url}`} loading="lazy" />
        </ImageButton>
      ))}
      {showAllButton && (
        <ShowAllButton type="button" onClick={onShowAll}>
          +{images.length - 4}
        </ShowAllButton>
      )}
    </GalleryWrapper>
  );
};

export default EnvironmentImageGallery;
